module.exports = __webpack_public_path__ + "r-v3/img/trash_red.d9e8703d.svg";